<div class="full-width-panel row">
    <img *ngIf="data" [src]="data" />
</div>